/**
 * ListItem accessible roles.
 * @public
 * @since 2.9.0
 */
enum BarAccessibleRole {

	/**
	 * Represents the ARIA role "toolbar".
	 * @public
	 */
	Toolbar = "Toolbar",

	/**
	 * Represents the ARIA role "none".
	 * @public
	 */
	None = "None"

}

export default BarAccessibleRole;
